import React, { useContext } from "react";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";
import SpellTheWordDemo from "./SpellTheWordDemo";

const InteractiveModules = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const moduleFeatures = [
    {
      title: t.interactive.features.exercises.title,
      description: t.interactive.features.exercises.description,
      icon: "📝",
    },
    {
      title: t.interactive.features.video.title,
      description: t.interactive.features.video.description,
      icon: "🎥",
    },
    {
      title: t.interactive.features.audio.title,
      description: t.interactive.features.audio.description,
      icon: "🎤",
    },
    {
      title: t.interactive.features.gamified.title,
      description: t.interactive.features.gamified.description,
      icon: "🎮",
    },
  ];

  return (
    <section id="interactive-modules" className="interactive-modules-section">
      <div className="interactive-modules-content">
        <h2>{t.interactive.title}</h2>
        <p className="dark-section-description">{t.interactive.description}</p>
        <div className="interactive-modules-grid">
          {moduleFeatures.map((feature, index) => (
            <div key={index} className="interactive-module-card">
              <div className="interactive-module-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
        <SpellTheWordDemo />
      </div>
    </section>
  );
};

export default InteractiveModules;
